import addToMailchimp from 'gatsby-plugin-mailchimp';
import React, { useState } from 'react';
import { API_RESPONSE_STATUS } from '../../config/constant';
import { SubscriptionForm, SubscriptionResult } from './components';

const Subscription = () => {
  const [subscribeLoadingStatus, setSubscribeLoadingStatus] = useState(false);
  const [subscribeFormStatus, setSubscribeFormStatus] = useState(
    API_RESPONSE_STATUS.DEFAULT
  );
  const [subscribeMessage, setSubscribeMessage] = useState('');

  const resetStatus = () => setSubscribeFormStatus(API_RESPONSE_STATUS.DEFAULT);

  const handleSubscribeForm = async ({ email }) => {
    setSubscribeLoadingStatus(true);
    let result;
    try {
      result = await addToMailchimp(email);
      if (result.result === 'success') {
        setSubscribeFormStatus(API_RESPONSE_STATUS.SUCCESS);
      } else {
        setSubscribeFormStatus(API_RESPONSE_STATUS.FAIL);
      }
      setSubscribeMessage(result.msg);
    } catch (error) {
      // eslint-disable-next-line no-empty
    } finally {
      setSubscribeLoadingStatus(false);
    }
  };

  const displayForm = () => {
    switch (subscribeFormStatus) {
      case API_RESPONSE_STATUS.DEFAULT:
        return (
          <SubscriptionForm
            handleSubscribeForm={handleSubscribeForm}
            subscribeLoadingStatus={subscribeLoadingStatus}
          />
        );
      case API_RESPONSE_STATUS.SUCCESS:
        return (
          <SubscriptionResult
            reset={resetStatus}
            isSuccess
            message={subscribeMessage}
          />
        );
      case API_RESPONSE_STATUS.FAIL:
        return (
          <SubscriptionResult
            reset={resetStatus}
            isSuccess={false}
            message={subscribeMessage}
          />
        );
      default:
        return <></>;
    }
  };

  return displayForm();
};

export default Subscription;
